export const menu = [
	{
		name: 'dashboard',
		title: 'Dashboard',
		url: '/dashboard',
		icon: 'ni-tv-2',
		textColor: 'text-primary',
	},
	{
		name: 'companies',
		title: 'Empresas',
		url: '/companies',
		icon: 'ni-building',
		textColor: 'text-warning',
	},
	{
		name: 'categories',
		title: 'Categorias',
		url: '/categories',
		icon: 'ni-archive-2',
		textColor: 'text-success',
	},
	// {
	// 	name: 'customers',
	// 	title: 'Clientes',
	// 	url: '/customers',
	// 	icon: 'ni-single-02',
	// 	textColor: 'text-secondary',
	// },
]
